<template>
  <b-modal
    size="sm"
    v-model="getShow"
    class="modal"
  >
    <Preloader v-if="isLoading" />
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Sent invoice {{ invoice && invoice.project ? invoice.project.label : ''}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="confirmCancel(cancel)"
      >
        <span class="material-icons">close</span>
      </button>
    </template>
    <div v-show="isSent" class="text-center text-uppercase text-danger">
      <h6>The invoice has been already sent</h6>
    </div>
    <FormGenerator
      :data="form"
      :showFormControls="false"
      :isLoading="isLoading"
      ref="sendEmailForm"
      @submit="submit"
    >
      <template v-slot:Body="slotProps">
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" />
      </template>
      <template v-slot:Items="slotProps">
        <div class="row flex justify-content-center m-1">
          <b-form-checkbox v-model="needSendBaseInvoice" name="check-button" switch class="switch m-2 ">
            {{ invoice && invoice.file_name && invoice.file_name !== '' ? invoice.file_name : 'System invoice' }}
          </b-form-checkbox>
          <b-form-checkbox v-model="needSendBaseWorkLogsReport" name="check-button" switch  class="switch m-2">
            {{ invoice && invoice.worklogs_report_file_name && invoice.worklogs_report_file_name !== '' ? invoice.worklogs_report_file_name : 'System worklogs' }}
          </b-form-checkbox>
          <b-form-checkbox v-for="(file, index) in files" :key="index" v-model="file.selected" name="check-button" switch class="switch m-2">
            {{ file.name }}
          </b-form-checkbox>
        </div>
        <b-form-file
          v-model="formFiles"
          @input="onFileUpload"
          multiple
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
          class="invoice-uploader"
        >
          <template slot="file-name">Choose a file or drop it here...</template>
        </b-form-file>
      </template>
    </FormGenerator>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="outline" class="button" @click.prevent="confirmCancel(cancel)">Cancel</b-button>
      <b-button variant="primary" class="button" @click.prevent="submitSendEmail(ok)">Send</b-button>
      </template>
  </b-modal>
</template>

<script>
  import Preloader from '@components/Preloader'
  import FormGenerator from '@components/FormGenerator'
  import FinanceSendEmailMixin from '../../mixins/FinanceSendEmailMixin'

  export default {
  components: {
    Preloader, FormGenerator
  },
  props: {
    invoiceId: {
      type: Number
    },
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  mixins: [FinanceSendEmailMixin],
  computed: {
    getShow: {
      get () {
        if (this.value) {
          this.initInvoiceModalData(this.invoiceId)
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isLoading () {
      return this.loading || this.isEmailFormLoading
    }
  },
  methods: {
    submit (data) {
      this.sendEmail(data, 'invoice')
    }
  }
}
</script>

<style scoped>
  .invoice-uploader {
      .custom-file-label {
          height: 100px;
          font-size: 13px;
          line-height: 22px;
          color: #3d5170;
          background: #f3f5f7;
          border: 1px solid #cacae1;
          border-radius: 4px;
          min-height: 32px;
          padding: 4px 12px;
          font-weight: 500;
      }
      .custom-file-label {
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .custom-file-label[data-browse] {
          &:after{
              content: none;
          }
      }
      height: 100px;
  }
</style>
